"use strict";
$(function ($) {
  /* ドロワーメニュー */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
    $(this).toggleClass('active');

    // bodyスクロール制御
    if ($('#js-hamburger').hasClass('active')) {
      $('body').css('overflow', 'hidden');  // 無効化
    } else {
      $('body').css('overflow', '');        // 元に戻す
    }
  });

  // ハンバーガーメニュー内リンククリックで閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click');
  });
});


/* ----- スクロール時にヘッダーにクラスを追加 ----- */
window.addEventListener('scroll', function() {
  const header = document.querySelector('.header');

  // スクロール位置が50px以上の場合
  if (window.scrollY > 30) {
    header.classList.add('on-scroll');
  } else {
    header.classList.remove('on-scroll');
  }
});

// パフォーマンス改善版（throttle使用）
/*
let lastScroll = 0;
let ticking = false;

window.addEventListener('scroll', function() {
  lastScroll = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(function() {
      const header = document.querySelector('.header');

      if (lastScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      ticking = false;
    });

    ticking = true;
  }
});
*/


/* ----- .fvを通過したら.fixedを表示 ----- */
window.addEventListener('scroll', function() {
  const fv = document.querySelector('.fv');
  const fixed = document.querySelector('.fixed');

  if (!fv || !fixed) return;

  const fvHeight = fv.offsetHeight;
  const scrollY = window.scrollY;

  if (scrollY > fvHeight) {
    fixed.classList.add('is-visible');
  } else {
    fixed.classList.remove('is-visible');
  }
});

// パフォーマンス改善版
/*
let ticking = false;

window.addEventListener('scroll', function() {
  if (!ticking) {
    window.requestAnimationFrame(function() {
      const fv = document.querySelector('.fv');
      const fixed = document.querySelector('.fixed');

      if (!fv || !fixed) return;

      const fvHeight = fv.offsetHeight;
      const scrollY = window.scrollY;

      if (scrollY > fvHeight) {
        fixed.classList.add('is-visible');
      } else {
        fixed.classList.remove('is-visible');
      }

      ticking = false;
    });

    ticking = true;
  }
});
*/


// /* ----- メガメニュー ----- */
// // メガメニューのホバー表示制御
// document.addEventListener('DOMContentLoaded', function() {
//   const megaMenuBtns = document.querySelectorAll('.megaMenu__btn');

//   megaMenuBtns.forEach(btn => {
//     const container = btn.querySelector('.megaMenu__container');

//     if (container) {
//       btn.addEventListener('mouseenter', function() {
//         container.classList.add('is-visible');
//       });

//       btn.addEventListener('mouseleave', function() {
//         container.classList.remove('is-visible');
//       });
//     }
//   });
// });


// $(function () {
//     // フェードイン判定の共通関数
//     function checkFadeElements() {
//         let windowHeight = $(window).height(),
//             scroll = $(window).scrollTop();

//         $(".fade").each(function () {
//             var targetPosition = $(this).offset().top;
//             if (scroll > targetPosition - windowHeight + 100) {
//                 $(this).addClass("is-active");
//             }
//         });
//     }

//     // アンカーリンク付きの場合のみ初期チェック
//     if (window.location.hash) {
//         checkFadeElements();
//     }

//     // スクロール時のチェック
//     $(window).scroll(function () {
//         checkFadeElements();
//     });
// });



// $(function () {
//   $(window).scroll(function () {
//     let windowHeight = $(window).height(), scroll = $(window).scrollTop();
//     $(".fade").each(function () {
//         var targetPosition = $(this).offset().top;
//         if (scroll > targetPosition - windowHeight + 100) {
//         $(this).addClass("is-active");
//       }
//     });
//   });
// });



// /* ----- ヘッダーシャドー ----- */
// $(function () {
//   $(window).on('scroll', function () {
//     if ($('.fv, .fvSub').height() < $(this).scrollTop()) {
//       $('.header').addClass('change-color');
//     } else {
//       $('.header').removeClass('change-color');
//     }
//   });
// });



// /* ----- newsスライダー ----- */
// document.addEventListener('DOMContentLoaded', function () {

//   let swiperInstance = null;
//   let currentBreakpoint = null; // 現在のブレークポイントを記録

//   function getCurrentBreakpoint() {
//     return window.innerWidth >= 768 ? 'desktop' : 'mobile';
//   }

//   function setSlideWidth() {
//     const slides = document.querySelectorAll('.topNews__item');
//     const isDesktop = window.innerWidth >= 768;

//     slides.forEach((slide) => {
//       if (isDesktop) {
//         slide.style.width = '';
//         slide.style.minWidth = '';
//         slide.style.flexShrink = '';
//       } else {
//         slide.style.width = '';
//         slide.style.minWidth = '';
//         slide.style.flexShrink = '';
//       }
//     });
//   }

//   function updateSwiperSettings() {
//     if (!swiperInstance || swiperInstance.destroyed) return;

//     const isDesktop = window.innerWidth >= 768;
//     const slides = document.querySelectorAll('.topNews__item');
//     const slideCount = slides.length;
//     const showPagination = isDesktop ? slideCount >= 3 : slideCount >= 2;
//     const enableLoop = slideCount >= 3;

//     // ページネーション表示制御
//     const paginationElement = document.querySelector('.topNews__pagination');
//     if (paginationElement) {
//       paginationElement.style.display = showPagination ? '' : 'none';
//     }

//     // Swiper設定を動的に更新
//     try {
//       // slidesPerViewとspaceBetweenを更新
//       swiperInstance.params.slidesPerView = isDesktop ? 2.3 : 1.2;
//       swiperInstance.params.spaceBetween = isDesktop ? 71 : 28;

//       // autoplayとloopの制御
//       if (enableLoop) {
//         if (!swiperInstance.params.loop) {
//           swiperInstance.params.loop = true;
//           swiperInstance.loopCreate();
//         }
//         if (!swiperInstance.autoplay.running) {
//           swiperInstance.autoplay.start();
//         }
//       } else {
//         if (swiperInstance.params.loop) {
//           swiperInstance.loopDestroy();
//           swiperInstance.params.loop = false;
//         }
//         if (swiperInstance.autoplay.running) {
//           swiperInstance.autoplay.stop();
//         }
//       }

//       // ページネーション再初期化
//       if (showPagination && swiperInstance.pagination) {
//         swiperInstance.pagination.init();
//         swiperInstance.pagination.render();
//         swiperInstance.pagination.update();
//       }

//       // スライド幅の設定
//       setSlideWidth();

//       // Swiperを更新（位置は保持される）
//       swiperInstance.update();

//     } catch (error) {
//       console.warn('Swiper update error:', error);
//       // 更新に失敗した場合のみ再初期化
//       initSwiper();
//     }
//   }

//   function initSwiper() {
//     // DOM要素の存在確認
//     const swiperContainer = document.querySelector('.topNews__slider');
//     if (!swiperContainer) {
//       return;
//     }

//     const isDesktop = window.innerWidth >= 768;
//     const slides = document.querySelectorAll('.topNews__item');
//     const slideCount = slides.length;
//     const showPagination = isDesktop ? slideCount >= 3 : slideCount >= 2;
//     const enableLoop = slideCount >= 3;

//     // 既存インスタンスの破棄
//     if (swiperInstance && !swiperInstance.destroyed) {
//       try {
//         swiperInstance.destroy(true, true);
//       } catch (error) {
//         console.warn('Swiper destroy error:', error);
//       }
//       swiperInstance = null;
//     }

//     setSlideWidth();

//     // ページネーション要素の表示制御
//     const paginationElement = document.querySelector('.topNews__pagination');
//     if (paginationElement) {
//       paginationElement.style.display = showPagination ? '' : 'none';
//     }

//     try {
//       const swiperConfig = {
//         slidesPerView: isDesktop ? 2.3 : 1.2,
//         spaceBetween: isDesktop ? 71 : 28,
//         loop: enableLoop,
//         slidesPerGroup: 1,
//         speed: 500,
//         autoplay: enableLoop ? {
//           delay: 5000,
//           disableOnInteraction: true,
//         } : false,

//         on: {
//           init: function() {
//             setSlideWidth();
//           }
//         }
//       };

//       // ページネーション設定
//       if (showPagination) {
//         swiperConfig.pagination = {
//           el: '.topNews__pagination',
//           type: 'bullets',
//           clickable: true,
//           bulletClass: 'topNews__pagination-bullet',
//           bulletActiveClass: 'topNews__pagination-bullet--active',
//         };
//       }

//       swiperInstance = new Swiper('.topNews__slider', swiperConfig);
//       currentBreakpoint = getCurrentBreakpoint();

//     } catch (error) {
//       console.error('Swiper initialization error:', error);
//     }
//   }

//   // 初期化
//   initSwiper();

//   // リサイズ時の処理を改善
//   let resizeTimer;
//   let lastWidth = window.innerWidth;

//   window.addEventListener('resize', function() {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(function() {
//       const newBreakpoint = getCurrentBreakpoint();
//       const currentWidth = window.innerWidth;

//       // 幅の変化が小さい場合（スマホのアドレスバー表示/非表示など）は無視
//       const widthDiff = Math.abs(currentWidth - lastWidth);
//       if (widthDiff < 50) {
//         return;
//       }

//       // ブレークポイントが変わった場合のみ再初期化
//       if (newBreakpoint !== currentBreakpoint) {
//         initSwiper();
//       } else {
//         // 同じブレークポイント内では設定更新のみ
//         updateSwiperSettings();
//       }

//       lastWidth = currentWidth;
//     }, 150); // タイマーも短縮
//   });

//   // orientationchange イベントも追加（モバイル向け）
//   window.addEventListener('orientationchange', function() {
//     setTimeout(function() {
//       initSwiper();
//     }, 300);
//   });

// });

// /* ----- newsスライダー ----- */
// document.addEventListener('DOMContentLoaded', function () {

//   let swiperInstance = null;

//   function setSlideWidth() {
//     const slides = document.querySelectorAll('.topNews__item');
//     const isDesktop = window.innerWidth >= 768;

//     slides.forEach((slide) => {
//       if (isDesktop) {
//         // slide.style.width = '62rem';
//         // slide.style.minWidth = '62rem';
//         // slide.style.flexShrink = '0';
//         slide.style.width = '';
//         slide.style.minWidth = '';
//         slide.style.flexShrink = '';
//       } else {
//         slide.style.width = '';
//         slide.style.minWidth = '';
//         slide.style.flexShrink = '';
//       }
//     });
//   }

//   function initSwiper() {
//     // DOM要素の存在確認を追加
//     const swiperContainer = document.querySelector('.topNews__slider');
//     if (!swiperContainer) {
//       return; // DOM要素が存在しない場合は処理を停止
//     }

//     const isDesktop = window.innerWidth >= 768;

//     // 既存のSwiperインスタンスが存在し、かつ破棄されていない場合のみ破棄
//     if (swiperInstance && !swiperInstance.destroyed) {
//       try {
//         swiperInstance.destroy(true, true);
//       } catch (error) {
//         console.warn('Swiper destroy error:', error);
//       }
//       swiperInstance = null; // インスタンスをnullに設定
//     }

//     setSlideWidth();

//     try {
//       swiperInstance = new Swiper('.topNews__slider', {
//         slidesPerView: isDesktop ? 2.3 : 1.2,
//         spaceBetween: isDesktop ? 71 : 28,
//         loop: true,
//         slidesPerGroup: 1,
//         speed: 500,
//         autoplay: {
//           delay: 5000,
//           disableOnInteraction: false,
//         },

//         pagination: {
//           el: '.topNews__pagination',
//           type: 'bullets',
//           clickable: true,
//           bulletClass: 'topNews__pagination-bullet',
//           bulletActiveClass: 'topNews__pagination-bullet--active',
//         },

//         on: {
//           init: function() {
//             setSlideWidth();
//           }
//         }
//       });
//     } catch (error) {
//       console.error('Swiper initialization error:', error);
//     }
//   }

//   // 初期化
//   initSwiper();

//   // リサイズ時の再初期化
//   let resizeTimer;
//   window.addEventListener('resize', function() {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(function() {
//       initSwiper();
//     }, 300);
//   });

//   // // ページを離れる際のクリーンアップ
//   // window.addEventListener('beforeunload', function() {
//   //   if (swiperInstance && !swiperInstance.destroyed) {
//   //     try {
//   //       swiperInstance.destroy(true, true);
//   //     } catch (error) {
//   //       console.warn('Swiper cleanup error:', error);
//   //     }
//   //   }
//   // });
// });


// /* ----- programスライダー ----- */
// document.addEventListener('DOMContentLoaded', function () {
//   let programSwiperInstance = null;
//   let programCurrentBreakpoint = null; // 現在のブレークポイントを記録

//   function getProgramCurrentBreakpoint() {
//     return window.innerWidth >= 768 ? 'desktop' : 'mobile';
//   }

//   function updateProgramSwiperSettings() {
//     if (!programSwiperInstance || programSwiperInstance.destroyed) return;

//     const isDesktop = window.innerWidth >= 768;

//     // Swiper設定を動的に更新
//     try {
//       // slidesPerViewとspaceBetweenを更新
//       programSwiperInstance.params.slidesPerView = isDesktop ? 'auto' : 1;
//       programSwiperInstance.params.spaceBetween = isDesktop ? 120 : 40;

//       // Swiperを更新（位置は保持される）
//       programSwiperInstance.update();

//     } catch (error) {
//       console.warn('Program Swiper update error:', error);
//       // 更新に失敗した場合のみ再初期化
//       initProgramSwiper();
//     }
//   }

//   function initProgramSwiper() {
//     // DOM要素の存在確認を追加
//     const programContainer = document.querySelector('.program__items');
//     if (!programContainer) {
//       return; // DOM要素が存在しない場合は処理を停止
//     }

//     // 既存のSwiperインスタンスが存在し、かつ破棄されていない場合のみ破棄
//     if (programSwiperInstance && !programSwiperInstance.destroyed) {
//       try {
//         programSwiperInstance.destroy(true, true);
//       } catch (error) {
//         console.warn('Program Swiper destroy error:', error);
//       }
//       programSwiperInstance = null; // インスタンスをnullに設定
//     }

//     const isDesktop = window.innerWidth >= 768;

//     try {
//       programSwiperInstance = new Swiper('.program__items', {
//         slidesPerView: isDesktop ? 'auto' : 1,
//         spaceBetween: isDesktop ? 120 : 40,
//         loop: true,
//         centeredSlides: true,
//         speed: 600,
//         autoplay: {
//           delay: 5000,
//           disableOnInteraction: true,
//         },
//         navigation: {
//           nextEl: '.program__button-next',
//           prevEl: '.program__button-prev',
//         },
//         pagination: {
//           el: '.program__pagination',
//           type: 'fraction',
//           formatFractionCurrent: function (number) {
//             return String(number).padStart(2, '0');
//           },
//           formatFractionTotal: function (number) {
//             return String(number).padStart(2, '0');
//           },
//           renderFraction: function (currentClass, totalClass) {
//             return '<span class="' + currentClass + '"></span>' +
//                   '<span class="swiper-pagination-separator"></span>' +
//                   '<span class="' + totalClass + '"></span>';
//           },
//         },
//         breakpoints: {
//           768: {
//             slidesPerView: 'auto',
//             spaceBetween: 120,
//           }
//         }
//       });

//       programCurrentBreakpoint = getProgramCurrentBreakpoint();

//     } catch (error) {
//       console.error('Program Swiper initialization error:', error);
//     }
//   }

//   initProgramSwiper();

//   // リサイズ時の処理を改善
//   let programResizeTimer;
//   let programLastWidth = window.innerWidth;

//   window.addEventListener('resize', function() {
//     clearTimeout(programResizeTimer);
//     programResizeTimer = setTimeout(function() {
//       const newBreakpoint = getProgramCurrentBreakpoint();
//       const currentWidth = window.innerWidth;

//       // 幅の変化が小さい場合（スマホのアドレスバー表示/非表示など）は無視
//       const widthDiff = Math.abs(currentWidth - programLastWidth);
//       if (widthDiff < 50) {
//         return;
//       }

//       // ブレークポイントが変わった場合のみ再初期化
//       if (newBreakpoint !== programCurrentBreakpoint) {
//         initProgramSwiper();
//       } else {
//         // 同じブレークポイント内では設定更新のみ
//         updateProgramSwiperSettings();
//       }

//       programLastWidth = currentWidth;
//     }, 150); // タイマーも短縮
//   });

//   // orientationchange イベントも追加（モバイル向け）
//   window.addEventListener('orientationchange', function() {
//     setTimeout(function() {
//       initProgramSwiper();
//     }, 300);
//   });

//   // beforeunloadイベントは削除（bfcache問題を回避）
// });




/* ----- スムースクロール ----- */
document.addEventListener('DOMContentLoaded', function() {
  // 固定ヘッダー（固定しない場合は = 0）
  const headerElement = document.querySelector('header');
  const headerHeight = headerElement ? headerElement.offsetHeight : 0; // ヘッダーが存在しない場合は0に設定

  // スマホサイズの時の追加オフセット（必要に応じて調整）
  const mobileOffset = 0; // 10px 追加オフセット
  // PCサイズの時の追加オフセット（必要に応じて調整）
  const pcOffset = 100; // 5px 上に調整

  // ページ内のスムーススクロール
  const anchorLinks = document.querySelectorAll('a[href*="#"]');

  if (anchorLinks && anchorLinks.length > 0) {
    anchorLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        const hash = e.currentTarget.hash;

        // ページトップへ("#"と"#top"）
        if (!hash || hash === '#top') {
          e.preventDefault();
          window.scrollTo({
            top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
            behavior: 'smooth',
          });
        }
        // アンカーへ
        else if (hash.slice(1)) {
          const target = document.getElementById(hash.slice(1));
          if (target) {
            e.preventDefault();
            let position = target.getBoundingClientRect().top + window.scrollY - headerHeight;

            // スマホサイズの場合の追加オフセット
            if (window.innerWidth <= 768) { // 768px 以下をスマホと判断
              position += mobileOffset;
            } else {
              // PCサイズの場合の追加オフセット
              position += pcOffset;
            }

            window.scrollTo({
              top: position,
              behavior: "smooth",
            });

            // URLにハッシュを含める
            history.pushState(null, '', hash);
          }
        }
      });
    });
  }
});




/* ----- コンタクトフォーム送信ボタンバリデーション ----- */
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.wpcf7-form');
  if (!form) return; // ← フォームがなければ何もしないで終了

  const submitButton = form.querySelector('.contactForm__btn button[type="submit"]');
  if (!submitButton) return; // ← 念のためボタンもチェック

  // 初期状態で無効化
  submitButton.disabled = true;

  function checkFormValidity() {
    const requiredFields = form.querySelectorAll('[aria-required="true"]');
    let allFilled = true;

    requiredFields.forEach(field => {
      if (field.type === 'checkbox' || field.type === 'radio') {
        const name = field.name;
        const checked = form.querySelector(`[name="${name}"]:checked`);
        if (!checked) allFilled = false;
      } else {
        if (!field.value.trim()) allFilled = false;
      }
    });

    const acceptanceCheckbox = form.querySelector('#acceptance');
    if (acceptanceCheckbox && !acceptanceCheckbox.checked) {
      allFilled = false;
    }

    submitButton.disabled = !allFilled;
  }

  form.addEventListener('input', checkFormValidity);
  form.addEventListener('change', checkFormValidity);
  checkFormValidity();
});

// document.addEventListener('DOMContentLoaded', function() {
//   const form = document.querySelector('.wpcf7-form');
//   const submitButton = form.querySelector('.contactForm__btn button[type="submit"]');

//   // 初期状態で無効化
//   submitButton.disabled = true;

//   // フォームの入力をチェックする関数
//   function checkFormValidity() {
//     // 必須のテキスト入力フィールド
//     const requiredFields = form.querySelectorAll('[aria-required="true"]');
//     let allFilled = true;

//     requiredFields.forEach(field => {
//       if (field.type === 'checkbox' || field.type === 'radio') {
//         // チェックボックス・ラジオボタンの場合
//         const name = field.name;
//         const checked = form.querySelector(`[name="${name}"]:checked`);
//         if (!checked) allFilled = false;
//       } else {
//         // テキスト入力の場合
//         if (!field.value.trim()) allFilled = false;
//       }
//     });

//     // acceptanceチェックボックスのチェック
//     const acceptanceCheckbox = form.querySelector('#acceptance');
//     if (acceptanceCheckbox && !acceptanceCheckbox.checked) {
//       allFilled = false;
//     }

//     submitButton.disabled = !allFilled;
//   }

//   // すべての入力フィールドにイベントリスナーを追加
//   form.addEventListener('input', checkFormValidity);
//   form.addEventListener('change', checkFormValidity);

//   // 初期チェック
//   checkFormValidity();
// });


// /* ----- コンタクトフォーム設定 ----- */
// document.addEventListener('DOMContentLoaded', () => {
//     // 入力内容を格納するための変数
//     let val;
//     // 入力フィールドのタイプを格納するための変数
//     let type;
//     // ラジオボタンの選択値を格納するための変数
//     let radio;
//     // チェックボックスの選択値を格納するための変数
//     let check;

//     // ラジオボタンの初期値を取得し、確認画面に反映させる
//     const radioButtons = document.querySelectorAll('[type="radio"]:checked');
//     radioButtons.forEach(button => {
//         // ラジオボタンの選択値を取得
//         radio = button.value;
//         // ラジオボタンの親要素からidを取得
//         const id = button.closest('[id]').id;
//         // 取得したidをクラス名に追加し、確認画面の値を設定
//         const confirmElement = document.querySelector(`.confirm_${id}`);
//         if (confirmElement) {
//             confirmElement.textContent = radio;
//         }
//     });

//     // 入力フィールドの内容が変更された場合の処理
//     const formInputs = document.querySelectorAll('.contactForm__item input, .contactForm__item select, .contactForm__item textarea');
//     formInputs.forEach(input => {
//         input.addEventListener('change', function () {
//             // 入力内容を取得
//             val = this.value;
//             // 入力フィールドのタイプを取得
//             type = this.getAttribute("type");
//             // ラジオボタンの場合の処理
//             if (type === "radio") {
//                 // ラジオボタンの選択値を取得
//                 radio = this.value;
//                 // ラジオボタンの親要素からidを取得
//                 const id = this.closest("[id]").id;
//                 // 取得したidをクラス名に追加し、確認画面の値を設定
//                 const confirmElement = document.querySelector(`.confirm_${id}`);
//                 if (confirmElement) {
//                     confirmElement.textContent = radio;
//                 }
//             }// チェックボックスの場合の処理
//             else if (type === "checkbox") {
//                 // チェックボックスの選択値を取得
//                 check = this.value;
//                 // チェックボックスの親要素からidを取得
//                 const id = this.closest("[id]").id;
//                 // 取得したidをクラス名に追加し、確認画面の値を設定
//                 const confirmElement = document.querySelector(`.confirm_${id}`);
//                 if (confirmElement) {
//                     confirmElement.textContent += check + " / ";
//                 }
//             }// その他の場合の処理
//             else {
//                 // 入力フィールドのidを取得
//                 const id = this.id;
//                 // 取得したidをクラス名に追加し、確認画面の値を設定
//                 const confirmElement = document.querySelector(`.confirm_${id}`);
//                 if (confirmElement) {
//                     confirmElement.textContent = val;
//                 }
//             }
//         });
//     });

//     // 確認ボタンをクリックした場合の処理
//     const confirmButton = document.querySelector(".confirm_button");
//     if (confirmButton) {
//     confirmButton.addEventListener('click', () => {
//         const firstForm = document.querySelector(".contactForm__first");
//         const confirmArea = document.querySelector(".confirm_area");

//         if (firstForm) firstForm.style.display = 'none';
//         if (confirmArea) confirmArea.style.display = 'block';

//         window.scrollTo(0, 0);  // ページを一番上にスクロール
//       });
//     }

//     // 戻るボタンをクリックした場合の処理
//     const backButton = document.querySelector(".back_button");
//     if (backButton) {
//         backButton.addEventListener('click', () => {
//         const firstForm = document.querySelector(".contactForm__first");
//         const confirmArea = document.querySelector(".confirm_area");
//         const naviElement = document.querySelector('#navi');

//         if (firstForm) firstForm.style.display = 'block';
//         if (confirmArea) confirmArea.style.display = 'none';

//         if (naviElement) {
//             window.scrollTo(0, naviElement.getBoundingClientRect().top);
//         }
//       });
//     }

//     // 必須項目が変更された場合の処理
//     const requiredInputs = document.querySelectorAll('[aria-required="true"]');
//     if (confirmButton && requiredInputs.length > 0) {
//         requiredInputs.forEach(input => {
//             input.addEventListener('input', () => {
//                 // フラグ
//                 let flag = true;
//                 // 必須項目をループで確認
//                 requiredInputs.forEach(requiredInput => {
//                     if (requiredInput.value === "") {
//                         flag = false;
//                     }
//                 });
//                 // フラグに基づいて確認ボタンを有効化/無効化
//                 confirmButton.disabled = !flag;
//             });
//         });
//     }

//     // 送信ボタンをクリックした場合の処理
//     document.addEventListener('wpcf7mailsent', (event) => {
//         location = '/thanks/'; /* ----- ここにサンクスページのURL記載 ----- */
//     }, false);
// });
